import React from "react";
import { useNavigate } from "react-router-dom";
import { Loading } from "../../../components/loading";
import { EmptyList } from "../../../components/empty-list";
import { Table, TableHeader, TableBody, TableRow, TableCell } from "../../../components/tables";
import { useVisits } from "../hooks";
import { formatDisplayDate } from "../../../helpers/date";
import { PrimaryContactCell } from "../../contacts/components";
import { visitOutcomeLabel } from "../../../helpers/enum-labels";

interface IProps {
  customerId: number;
}

export const VisitsList: React.FC<IProps> = ({ customerId }) => {
  const navigate = useNavigate();
  const { data, loading } = useVisits({ where: { customerId } });

  if (loading) return <Loading />;

  if (!data?.visits?.results?.length) {
    return <EmptyList text="Aucune visite" />;
  }

  return (
    <Table>
      <TableHeader>
        <TableRow hover={false}>
          <TableCell header>Date</TableCell>
          <TableCell header>Contact</TableCell>
          <TableCell header>Résultat</TableCell>
          <TableCell header>Relance</TableCell>
        </TableRow>
      </TableHeader>
      <TableBody>
        {data?.visits?.results?.map((visit) => (
          <TableRow
            key={`visit-${visit.id}`}
            onClick={() => navigate(`/visit/${visit.id}`)}
          >
            <TableCell>{formatDisplayDate(visit.visitDate)}</TableCell>
            <TableCell>
              <PrimaryContactCell customerId={customerId} />
            </TableCell>
            <TableCell>{visitOutcomeLabel(visit.outcome)}</TableCell>
            <TableCell>{formatDisplayDate(visit.followUpDate)}</TableCell>
          </TableRow>
        ))}
      </TableBody>
    </Table>
  );
};
